import * as DOMPurify from 'dompurify';

export function trustedHTMLHandler(html) {
    const config = {
        ADD_TAGS: ['head', 'meta', '#comment'],
        ADD_ATTR: ['name', 'content'],
        WHOLE_DOCUMENT: true,
        ALLOW_UNKNOWN_PROTOCOLS: true,
    };

    // Only request Trusted Types when the browser exposes a factory
    if (typeof window !== 'undefined') {
        const trustedTypesFactory = window.trustedTypes || window.msTrustedTypes || null;
        if (trustedTypesFactory && typeof trustedTypesFactory.createPolicy === 'function') {
            config.RETURN_TRUSTED_TYPE = true;
        }
    }

    return DOMPurify.sanitize(html, config);
}

export default trustedHTMLHandler;
